(function () {
  const STORAGE_KEY = "wishlist_handles_v1";

  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch { return []; }
  }

  function setList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    updateCount();
    syncButtons();
  }

  function has(handle) { return getList().includes(handle); }

  function add(handle) {
    const list = getList();
    if (!list.includes(handle)) list.push(handle);
    setList(list);
  }

  function remove(handle) {
    const list = getList().filter(h => h !== handle);
    setList(list);
  }

  function toggle(handle) { has(handle) ? remove(handle) : add(handle); }

  function updateCount() {
    const count = getList().length;
    document.querySelectorAll("[data-wishlist-count]").forEach(el => {
      el.textContent = String(count);
      el.hidden = count <= 0;
    });
  }

  function syncButtons() {
    document.querySelectorAll("[data-wishlist-btn]").forEach(btn => {
      const handle = btn.getAttribute("data-product-handle");
      const active = has(handle);
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-label", active ? "Remove from wishlist" : "Add to wishlist");
      const icon = btn.querySelector(".wishlist-btn__icon");
      if (icon) icon.textContent = active ? "♥" : "♡";
    });
  }

  async function renderWishlistPage() {
    const grid = document.querySelector("[data-wishlist-grid]");
    if (!grid) return;

    const empty = document.querySelector(".wishlist-empty");
    const handles = getList();

    if (!handles.length) {
      if (empty) empty.hidden = false;
      grid.innerHTML = "";
      return;
    }
    if (empty) empty.hidden = true;

    const products = await Promise.all(handles.map(async (handle) => {
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) return null;
        return await res.json();
      } catch {
        return null;
      }
    }));

    const valid = products.filter(Boolean);
    const validHandles = valid.map(p => p.handle);
    if (validHandles.length !== handles.length) setList(validHandles);

    grid.innerHTML = valid.map(p => {
      const img = (p.images && p.images[0]) ? p.images[0] : "";
      const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : "INR";
      const price = (p.price / 100).toLocaleString(undefined, { style: "currency", currency });

      return `
        <article class="wishlist-card">
          <a href="${p.url}">
            ${img ? `<img class="wishlist-card__img" src="${img}" alt="${p.title}">` : ""}
          </a>
          <div class="wishlist-card__body">
            <p class="wishlist-card__title"><a href="${p.url}">${p.title}</a></p>
            <div class="wishlist-card__meta">
              <span>${price}</span>
              <button class="wishlist-remove" type="button" data-wishlist-remove="${p.handle}">Remove</button>
            </div>
          </div>
        </article>
      `;
    }).join("");

    grid.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-wishlist-remove]");
      if (!btn) return;
      remove(btn.getAttribute("data-wishlist-remove"));
      renderWishlistPage();
    });
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-wishlist-btn]");
    if (!btn) return;
    toggle(btn.getAttribute("data-product-handle"));
  });

  document.addEventListener("DOMContentLoaded", () => {
    updateCount();
    syncButtons();
    renderWishlistPage();
  });
})();
